// import React from 'react'

// const ViewPrintBody = () => {
//   return (
//     <div>ViewPrintBody</div>
//   )
// }

// export default ViewPrintBody

import * as React from "react";
import { useState, useEffect, useContext } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import SystemAlert from "../../components/common/SystemAlert";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrnDetails from "../../components/grid/ViewDataGridGrnDetails";
import ViewGrnSupplier from "../../components/grn/ViewGrnSupplier";
import ViewGrnPo from "../../components/grn/ViewGrnPo";
import ViewGrnAttachments from "../../components/grn/ViewGrnAttachments";
import ViewGrnBillInfo from "../../components/grn/ViewGrnBillInfo";
import ViewSidebarOutlinedIcon from "@mui/icons-material/ViewSidebarOutlined";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import GrnStatusHistory from "../../components/grn/GrnStatusHistory";
// @ts-ignore
import GrnPdf from "../../features/documents/GrnPdf";
// @ts-ignore
import RejectionNotePdf from "../../features/documents/RejectionNotePdf";
// @ts-ignore
import ReturnNotePdf from "../../features/documents/ReturnNotePdf";
// @ts-ignore
import DebitNotePdf from "../../features/documents/DebitNotePdf";
import ViewGrnReturnInfo from "./ViewGrnReturnInfo";
import { AnyForNow, GrnData, GrnItem } from "../../features/grn/types";
import { useGrnDetailLayout } from "../../features/grn/hooks/useGrnDetailLayout";
import { GRN_VIEW_DETAIL } from "../../utils/sys/GrnConstants";
import GrnReturnStatusHistory from "./GrnReturnStatusHistory";

interface ViewDetailGrnBodyProps {
  statusCode?: string | number;
  grnItems?: GrnItem[] | AnyForNow;
  selectedSupplier?: AnyForNow;
  grnDetailsForm?: AnyForNow;
  attachments?: AnyForNow;
  grnHeader?: AnyForNow;
  grncode?: string;
  trackingDetails?: AnyForNow;
  grnstatuscode?: string | number;
  grnDocuments?: AnyForNow;
  grnReturns?: AnyForNow;
  grnPaySummery?: AnyForNow[];
  grnPayTax?: AnyForNow[];
  grnData?: GrnData | AnyForNow;
  totalGross?: number | string;
  taxValues?: AnyForNow;
  grnTaxTypes?: AnyForNow[];
  grnCompany?: AnyForNow;
  grncharges?: AnyForNow[];
  origin?: string;
  addedCharges?: AnyForNow[];
  grnReturnList?: AnyForNow[];
  grnReturnMaster?: AnyForNow[];
  grnRejectList?: AnyForNow[];
  otherchargevalue?: AnyForNow[];
  processResponse?: AnyForNow[];
  grncal?: AnyForNow;
  calSummary?: AnyForNow;
  trsts?: AnyForNow;
  page?: string;
  doctype?: string;
  grnreturncode?: string;
  debitnoteno?: string;
}

const ViewPrintBody: React.FC<ViewDetailGrnBodyProps> = ({
  statusCode,
  grnItems,
  selectedSupplier,
  grnDetailsForm,
  attachments,
  grnHeader,
  grncode,
  trackingDetails,
  grnstatuscode,
  grnDocuments,
  grnReturns,
  grnPaySummery,
  grnPayTax,
  grnData,
  totalGross,
  taxValues,
  grnTaxTypes,
  grnCompany,
  grncharges,
  origin,
  addedCharges,
  grnReturnList,
  grnReturnMaster,
  grnRejectList,
  otherchargevalue,
  processResponse,
  grncal,
  calSummary,
  page,
  doctype,
  grnreturncode,
  debitnoteno,
}) => {
  const normalizedStatusCode =
    statusCode === undefined || statusCode === null ? "" : String(statusCode);
  console.log("ViewDetailGrnBody processResponse:", processResponse);
  const theme = useTheme();
  const styles = useStyles(theme);
  const { setPageData } = useContext(PageDataContext);
  const {
    rightSidebarRef,
    rightSidebarOpen,
    toggleRightSidebar,
    docType,
    openPdf,
    setOpenPdf,
    handleOpenPdf,
  } = useGrnDetailLayout();
  const [alert, setAlert] = useState<{
    open: boolean;
    type: string;
    message: string;
  }>({
    open: false,
    type: "success",
    message: "",
  });
  // Toggle function handled via hook
  useEffect(() => {
    setPageData({
      title: "GRN Summary",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const handleAlertClose = () => {
    setAlert({ ...alert, open: false });
  };

  console.log("grncode", grncode);
  console.log("statuscode", statusCode);

  return (
    <>
      
      <Box sx={styles.grn_supplier_container}>
        <Grid container spacing={2}>
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography sx={styles.title_text}>
              {(GRN_VIEW_DETAIL.HOLD_LIKE_STATUSES as readonly string[]).includes(String(statusCode))
                ? "Hold GRN"
                : grncode
                ? `GRN : ${grncode}`
                : "Submit GRN"}

              {/* {grncode ? `GRN : ${grncode}` : "Submit GRN"} */}
            </Typography>

            
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Divider />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Box
              sx={{
                width: {
                  xs: "80%",
                  sm: "80%",
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                },
              }}
            >
              {/* <ViewGrnSupplier
                onOpenSidebar={toggleRightSidebar}
                selectedSupplier={selectedSupplier}
              statusCode={statusCode} 
                grnHeader={grnHeader}
                grncode={grncode}
                grnstatuscode={grnstatuscode}
                origin ={origin}
               
              /> */}
            </Box>
          </Grid>

          <Grid
            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
            sx={{
              width: "50%",
              display: "flex",
              justifyItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <Box
              sx={{
                width: {
                  xs: "80%",
                  sm: "80%",
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                },
                display: "flex",
                justifyItems: "flex-end",
              }}
            >
              {/* <ViewGrnPo
                grnDetailsForm={grnDetailsForm}
                grnHeader={grnHeader}
              /> */}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box>
        {/* <ViewDataGridGrnDetails
          grnItems={grnItems}
          grnDocuments={grnDocuments}
          grnReturns={grnReturns}
          grnRejectList={grnRejectList}
          grnData={grnData}
          origin={origin}
        /> */} 
     
        {page === "ReturnNote" ? (
  <ReturnNotePdf
    docType="Return Note"
    grnHeader={grnHeader}
    grnItems={grnItems}
    selectedSupplier={selectedSupplier}
    grnPaySummery={grnPaySummery}
    grnData={grnData}
    grnDetailsForm={grnDetailsForm}
    grnCompany={grnCompany}
    grnReturns={grnReturns}
      grnRejectList={grnRejectList}
      grnreturncode={grnreturncode}
  />
) : page === "DebitNote" ? (
  <DebitNotePdf
    docType="Debit Note"
                 grnHeader={grnHeader}
    grnItems={grnItems}
                grnPaySummery={grnPaySummery}
            
                grnReturns={grnReturns}
                grnCompany={grnCompany}
                grnReturnList={grnReturnList}
                grnReturnMaster={grnReturnMaster}
                returnedProducts={grnReturnList}
                  grnRejectList={grnRejectList}
                  grnreturncode={grnreturncode}
                  debitnoteno={debitnoteno}
               
              />
)



: (
  <GrnPdf
    docType="GRN Note"
    grnHeader={grnHeader}
    grnItems={grnItems}
    selectedSupplier={selectedSupplier}
    grnPaySummery={grnPaySummery}
    grnData={grnData}
    grnDetailsForm={grnDetailsForm}
    grnCompany={grnCompany}
      grnRejectList={grnRejectList}
    grnReturns={grnReturns}
  />
)}
      </Box>

      {/* Attachenments and price */}

      {/* <Box pt={2} sx={styles.grn_search_container}>
        <Grid container spacing={6}>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Typography sx={styles.grn_sub_title_text} gutterBottom>
              Attached Documents:
            </Typography>
            <Divider />
            <ViewGrnAttachments
              attachments={attachments}
              grnData={grnData}
              grnDocuments={grnDocuments}
            />
          </Grid>
             {!["9", "10", "11", "12","13"].includes(normalizedStatusCode) ? (
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Typography sx={styles.grn_sub_title_text} gutterBottom>
              Billing Information
            </Typography>
            <Divider />
            <ViewGrnBillInfo
              grnPaySummery={grnPaySummery}
              grnPayTax={grnPayTax}
              grnData={grnData}
              totalGross={totalGross}
              taxValues={taxValues}
              grnTaxTypes={grnTaxTypes}
           grncharges={grncharges}
           addedCharges={addedCharges}
              origin ={origin}
         otherchargevalue={otherchargevalue}
         processResponse={processResponse}
         calSummary={calSummary}
         grncal={grncal}
            />
          </Grid>
          ) : null}

               {["9", "10", "11", "12","13"].includes(normalizedStatusCode) ? (
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Typography sx={styles.grn_sub_title_text} gutterBottom>
              Billing Information
            </Typography>
            <Divider />
            <ViewGrnReturnInfo
              grnPaySummery={grnPaySummery}
              grnPayTax={grnPayTax}
              grnData={grnData}
              totalGross={totalGross}
              taxValues={taxValues}
              grnTaxTypes={grnTaxTypes}
          grncharges={grncharges}
          addedCharges={addedCharges}
             origin ={origin}
             grnReturns={grnReturns}
              grnItems={grnItems}
              grnReturnList={grnReturnList}
              grnReturnMaster={grnReturnMaster}
                   processResponse={processResponse}
            />
          </Grid>
          ) : null}
          {origin !== "CreateGrn" && origin !== "EditGrn" && (
            <Grid
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <Divider />
             {!["7","8","9", "10", "11", "12","13"].includes(normalizedStatusCode) ? (
                <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{ ...styles.btn_primary }}
                onClick={() => handleOpenPdf("Good Received Note")}
              >
                View GRN Note
              </Button>
              ): null}

               {["9", "10", "11", "12","13"].includes(normalizedStatusCode) ? (
                 <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                  onClick={() => handleOpenPdf("Debit Note")}
                >
                View Debit Note
                </Button>
              ): null}
             
            {["9", "10", "11", "12","13"].includes(normalizedStatusCode) ? (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                  onClick={() => handleOpenPdf("Return Note")}
                >
                  View Return Note
                </Button>
             ) : !["7","8"].includes(normalizedStatusCode) ? (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                  onClick={() => handleOpenPdf("Rejection Note")}
                >
                  View Reject Note
                </Button>
              ): null}



            </Grid>
          )}
        </Grid>
      </Box> */}
      <Divider />

      <Dialog
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {docType} Preview
          <IconButton
            aria-label="close"
            onClick={() => setOpenPdf(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {/* {docType === "Return Note" ? (
            <ReturnNotePdf
              grnHeader={grnHeader}
              grnItems={grnItems}
              docType={docType}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
              grnReturns={grnReturns}
              grnData={grnData}
              grnCompany={grnCompany}
              grnReturnList={grnReturnList}
              grnReturnMaster={grnReturnMaster}
              returnedProducts={grnReturnList}
                 
            />
          ) : docType === "Rejection Note" ? (
            <RejectionNotePdf
              grnHeader={grnHeader}
              docType={docType}
              grnItems={grnItems}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
              grnData={grnData}
              grnReturns={grnReturns}
              grnRejectList={grnRejectList}
              grnCompany={grnCompany}
                
            />
          ) : docType === "Debit Note" ? (
            <DebitNotePdf
              grnHeader={grnHeader}
              grnItems={grnItems}
              docType={docType}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
              grnReturns={grnReturns}
              grnData={grnData}
              grnCompany={grnCompany}
              grnReturnList={grnReturnList}
              grnReturnMaster={grnReturnMaster}
              returnedProducts={grnReturnList}
                 
            />)
          
          
          : (
            <GrnPdf
              docType={docType}
              grnHeader={grnHeader}
              grnItems={grnItems}
              selectedSupplier={selectedSupplier}
              grnPaySummery={grnPaySummery}
              grnData={grnData}
              grnDetailsForm={grnDetailsForm}
              grnCompany={grnCompany}
          grnReturns={grnReturns}
            />
          )} */}   
        </DialogContent>
      </Dialog>

      <SystemAlert
        open={alert.open}
        type={alert.type}
        message={alert.message}
        onClose={handleAlertClose}
      />
    </>
  );
};

export default ViewPrintBody;
